// InboxPage (`/me/inbox`, REQ-WF-005/006): agregação de tarefas, aprovações e exceções em SelfScope.
import { PageHeader } from '@giyus/patterns';
import { Skeleton } from '@giyus/ui';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProblemAlert } from '../../components';
import { AccountMeNav } from '../../pages/Account';
import type { InboxItemsQuery } from './api/contract.preview';
import { useInboxItems } from './api/queries';
import { InboxCounters } from './components/InboxCounters';
import { InboxFilters, type InboxFiltersValue } from './components/InboxFilters';
import { InboxList } from './components/InboxList';

export function InboxPage() {
  const { t } = useTranslation('workflow');
  const [filters, setFilters] = useState<InboxFiltersValue>({
    kind: 'all',
    tenantId: 'all',
    overdue: false,
  });

  const query = useMemo<InboxItemsQuery>(
    () => ({
      ...(filters.kind === 'all' ? {} : { kind: [filters.kind] }),
      ...(filters.tenantId === 'all' || filters.tenantId === 'network'
        ? {}
        : { tenantId: filters.tenantId }),
      ...(filters.overdue ? { overdue: true } : {}),
    }),
    [filters],
  );
  const { data, isLoading, isError, error, refetch } = useInboxItems(query);

  const items = data?.items ?? [];
  const filteredByNetwork =
    filters.tenantId === 'network' ? items.filter((item) => item.scope.level === 'Network') : items;

  return (
    <section className="flex flex-col gap-5" data-testid="inbox-page">
      <PageHeader
        eyebrow="Minha conta · Avisos"
        title={t('inbox.title')}
        description={t('inbox.subtitle')}
      />
      <AccountMeNav />
      <InboxCounters />
      <InboxFilters value={filters} onChange={setFilters} />
      {isError ? (
        <ProblemAlert
          error={error}
          onRetry={() => {
            void refetch();
          }}
        />
      ) : isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : (
        <InboxList items={filteredByNetwork} />
      )}
    </section>
  );
}
